import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConsentBanner, ConsentDialog, ConsentProvider } from '@digiwedge/cmp-consent-react';
import { CartProvider } from './hooks/useCart';
import AppRoutes from './routes';
import { consentCore, consentStrings } from './consent';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  },
});

export function App() {
  return (
    <ConsentProvider core={consentCore} strings={consentStrings}>
      <QueryClientProvider client={queryClient}>
        <CartProvider>
          <AppRoutes />
        </CartProvider>
      </QueryClientProvider>
      <ConsentBanner />
      <ConsentDialog />
    </ConsentProvider>
  );
}

export default App;
